import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Home as HomeIcon, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import Logo from '../components/Logo';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-orange-50 to-amber-50 flex flex-col">
      <nav className="p-6">
        <Link to="/"><Logo /></Link>
      </nav>

      <div className="flex-1 flex items-center justify-center px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-2xl"
        >
          <div className="text-[9rem] md:text-[12rem] font-bold leading-none bg-gradient-to-br from-orange-600 to-amber-600 bg-clip-text text-transparent mb-4">
            404
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            Page introuvable
          </h1>
          <p className="text-lg text-slate-600 mb-10 max-w-md mx-auto">
            La page que vous cherchez n'existe pas ou a été déplacée. 
            Retournez à l'accueil pour découvrir APELGP.
          </p>
          <Link to="/">
            <Button
              size="lg"
              className="bg-gradient-to-r from-orange-600 to-amber-600 text-white hover:shadow-xl hover:scale-105 transition-all"
              data-testid="404-home-btn"
            >
              <ArrowLeft className="w-5 h-5 mr-2" />
              Retour à l'accueil
            </Button>
          </Link>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFound;
